import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import ButtonComponent from "@components/Theme/Button/Button"
import ButtonContainer from "@components/WebsiteRevamp/ButtonContainer/ButtonContainer"
import Typography, {
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {
	AdvancedSideAssetModuleType,
	CustomerStoryModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import CustomersCardsSection from "../../Expertise/ExpertiseCustomerCards/CustomersCards/CustomersCardsSection"

type Props = {
	data: AdvancedSideAssetModuleType
	stories: CustomerStoryModuleType[]
}

const CompanyCustomersSection = (props: Props) => {
	return (
		<section>
			<Separator size={128}>
				<ContainerWrapper>
					<Typography
						content={props.data.sectionTitle}
						variant={Variant.SectionTitle}
					/>
					<Typography
						content={props.data.sectionSubtitle}
						variant={Variant.SectionSubtitle}
					/>
				</ContainerWrapper>
				<Separator size={64}>
					<CustomersCardsSection data={props.stories} />
				</Separator>
				<ContainerWrapper>
					<ButtonContainer>
						<ButtonComponent
							buttonType={"secondary"}
							link={props.data.sectionBottomButtonLink}
							asLink
						>
							{props.data.sectionBottomButton}
						</ButtonComponent>
					</ButtonContainer>
				</ContainerWrapper>
			</Separator>
		</section>
	)
}

export default CompanyCustomersSection
